{
  "LOGIN": {
    "TITLE": "Prijava u kontaktni centar",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Unesite valjanu e-mail adresu"
    },
    "PASSWORD": {
      "LABEL": "Lozinka",
      "PLACEHOLDER": "Lozinka"
    },
    "API": {
      "SUCCESS_MESSAGE": "Login Successful",
      "ERROR_MESSAGE": "Could not connect to chat server, Please try again later",
      "UNAUTH": "Username / Password Incorrect. Please try again",
      "ACCOUNT_DEACTIVATED": "Vaš račun je deaktiviran. Obratite se administratoru.",
      "PASSWORD_LOGIN_DISABLED": "Prijava lozinkom je onemogućena za vaš račun. Prijavite se putem OAutha (npr. Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Prijava putem Googlea",
      "BUSINESS_ACCOUNTS_ONLY": "Za prijavu koristite svoju poslovnu e-mail adresu",
      "NO_ACCOUNT_FOUND": "Nismo pronašli račun za vašu e-mail adresu."
    },
    "FORGOT_PASSWORD": "Zaboravili ste lozinku?",
    "CREATE_NEW_ACCOUNT": "Create new account",
    "SUBMIT": "Prijava"
  }
}
